module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-view')], 1)])]), _vm._v(" "), ((!(this.$route.path == '/order') && !(this.$route.path == '/order/') && !(this.$route.path == '/cart') && !(this.$route.path == '/cart/') && !(this.$route.path == '/checkout') && !(this.$route.path == '/checkout/'))) ? _c('component-footer') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42197817"}!./src/pages/Boxpoint/Template/template.html
// module id = 568
// module chunks = 0